import { Link } from "react-router-dom";
import { Logo, BrandInline } from "./Logo";
import { FlagRow } from "./Flags";
import { MaskLines, Em } from "./Motion";
import { MagneticButton } from "./Magnetic";
import { OpenTag } from "./OpenTag";
import { NAV_LINKS, WINGS, US_ADDRESS, INDIA_ADDRESS } from "@/lib/site";

const Office = ({ flags, wing, children, testid }) => (
  <div data-testid={testid}>
    <div className="flex flex-wrap items-center gap-3">
      <FlagRow ids={flags} size="w-[18px]" />
      <OpenTag tz={wing.tz} testid={`${testid}-open-tag`} />
    </div>
    <p className="font-display mt-4 text-lg font-bold">{wing.name} <span className="font-mono-x text-xs font-normal text-[#a8a29a]">/ {wing.domain}</span></p>
    <a href={`mailto:${wing.email}`} className="ul-draw mt-2 block w-fit text-[#e7e1d6]">{wing.email}</a>
    <a href={`tel:${wing.tel}`} className="ul-draw mt-1 block w-fit text-[#e7e1d6]">{wing.phone}</a>
    {children}
  </div>
);

export default function Footer() {
  return (
    <footer className="grain grain-dark relative overflow-hidden bg-[#0E0E10] px-5 pb-10 pt-24 text-[#F1ECE2] sm:px-8" data-testid="site-footer">
      <div className="relative mx-auto max-w-[1400px]">
        <MaskLines as="h2" lines={[<>the clock is</>, <Em className="text-[#FF4D1A]">already running.</Em>]}
          className="font-display text-5xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-7xl lg:text-[7.5rem]" />
        <div className="mt-10 flex flex-wrap gap-4">
          <MagneticButton to="/clients" tone="signal" testid="footer-hire-btn">i'm hiring</MagneticButton>
          <MagneticButton to="/talent" tone="paper" testid="footer-talent-btn">i'm the hire</MagneticButton>
        </div>
        <div className="mt-20 grid gap-12 border-t border-white/15 pt-12 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Logo light />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#cfc9be]">One company, two wings. IT people for teams that can't afford to wait.</p>
          </div>
          <Office flags={["us"]} wing={WINGS.pitsus} testid="footer-office-us">
            <p className="mt-3 text-sm leading-relaxed text-[#cfc9be]" data-testid="footer-us-address">{US_ADDRESS.map((l) => <span key={l} className="block">{l}</span>)}</p>
          </Office>
          <Office flags={["uk", "eu", "apac"]} wing={WINGS.pitsind} testid="footer-office-in">
            <p className="mt-3 text-sm leading-relaxed text-[#cfc9be]" data-testid="footer-in-address">{INDIA_ADDRESS.map((l) => <span key={l} className="block">{l}</span>)}</p>
          </Office>
          <nav className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-${l.testid}`} className="ul-draw w-fit text-[#e7e1d6] hover:text-white">{l.label}</Link>
            ))}
          </nav>
        </div>
        <div className="font-mono-x mt-16 flex flex-col justify-between gap-3 text-xs text-[#a8a29a] sm:flex-row">
          <span className="flex flex-wrap items-center gap-x-2">© {new Date().getFullYear()} <BrandInline light className="text-xs" /> · PITSUS & PITSIND</span>
          <span>first reply ≤ 60 min · first shortlist ≤ 5 hrs</span>
        </div>
      </div>
    </footer>
  );
}
